/**
 * Main Layout Component
 *
 * Responsive layout with navigation and player.
 * - Mobile: Bottom nav + mini player above it
 * - Desktop: Sidebar nav + mini player at bottom
 */

import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';
import { MiniPlayer } from '../player/MiniPlayer';
import { ExpandedPlayer } from '../player/ExpandedPlayer';
import { AudioEngine } from '../player/AudioEngine';
import { usePlayerStore } from '@/stores/player';

export function Layout() {
  const { isExpanded } = usePlayerStore();

  return (
    <div className="h-full bg-black">
      {/* Audio playback engine (invisible) */}
      <AudioEngine />
      {/* Desktop layout */}
      <div className="hidden md:flex h-full">
        {/* Sidebar */}
        <aside className="w-64 shrink-0 border-r border-outline-variant bg-surface-container overflow-y-auto">
          <Navigation variant="sidebar" />
        </aside>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto pb-player-mini">
          <Outlet />
        </main>
      </div>

      {/* Mobile layout */}
      <div className="md:hidden h-full flex flex-col">
        {/* Main content */}
        <main className="flex-1 overflow-y-auto pb-[calc(theme(height.player-mini)+theme(spacing.16))]">
          <Outlet />
        </main>

        {/* Mini player (above nav) */}
        <MiniPlayer />

        {/* Bottom navigation */}
        <Navigation variant="bottom" />
      </div>

      {/* Desktop mini player */}
      <div className="hidden md:block">
        <MiniPlayer />
      </div>

      {/* Expanded player overlay */}
      {isExpanded && <ExpandedPlayer />}
    </div>
  );
}
